<template>
    <div>
        <report-header
            :title="title"
            :isLoading="isLoading"
            :reportPagination="pagination"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />

        <b-card id="report-card">
            <div v-if="!loaded">
                <p class="mt-3">
                    Please select the
                    <a @click="handleOpenFilter" class="text-link">filter</a>
                </p>
            </div>
            <div v-else id="report-body" class="w-100">
                <div v-if="loaded && !isLoading" class="summary-table">
                    <h4 class="mt-3">Summary</h4>
                    <b-table-simple class="mb-4">
                        <tbody>
                            <tr>
                                <td class="">{{ summaryTitle }}</td>
                                <td class="">{{ total }}</td>
                            </tr>
                        </tbody>
                    </b-table-simple>
                </div>
                <div v-if="length > 0">
                    <QTable
                        :data="results"
                        :columns="columns"
                        :loading="isLoading"
                        :rows-per-page-options="[0]"
                        :visible-columns="visibleColumns"
                        row-key="index"
                        hide-bottom
                    >
                        <template v-slot:body-cell-name="props">
                            <q-td :props="props" class="">
                                <client-name
                                    :use-router="USE_CLIENT_MODULE_VUE"
                                    :client="generateClientObject(props.row)"
                                />
                            </q-td>
                        </template>
                    </QTable>
                </div>
                <div v-else>
                    <QTable
                        :data="[]"
                        :columns="columns"
                        :loading="isLoading"
                        :rows-per-page-options="[0]"
                        :visible-columns="visibleColumns"
                        row-key="index"
                        hide-bottom
                    ></QTable>
                    <div class="py-3" v-if="!isLoading">
                        <i>No records available</i>
                    </div>
                </div>
            </div>
        </b-card>

        <FilterDateRange ref="filterDateRange" :data="data" />
    </div>
</template>
<script>
import { QTable } from "quasar";
import { DateTime } from "luxon";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import FilterDateRange from "@/module/report/module/filter-date-range";

export default {
    mixins: [Report],
    components: {
        QTable,
        FilterDateRange,
        ClientName: () => import("@/components/commons/client-name"),
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: false,
            meta: {},
            page: 1,
            pagination: {},
            results: [],
            total: 0,
            dateRange: "",
            length: 0,
            isLoading: false,
            title: "New Engaged Clients",
            abortController: [],
            indexAxios: 0,
            isDestroyed: false,
            isRecordSharing: false,
            homeLocation: "",
            params: {
                to: null,
                home_location_id: null
            },
            columns: [
                {
                    name: "name",
                    field: "name",
                    label: "Name",
                    align: "left",
                    style: "vertical-align: top; min-width: 200px;"
                },
                {
                    name: "address",
                    field: "address",
                    label: "Address",
                    align: "left",
                    style: "vertical-align: top; min-width: 110px;"
                },
                {
                    name: "city",
                    field: "city",
                    label: "City",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "state",
                    field: "state",
                    label: "State",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "zipcode",
                    field: "zipcode",
                    label: "Zip Code",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "county",
                    field: "county",
                    label: "County",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "country",
                    field: "country",
                    label: "Country",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "email",
                    field: "email",
                    label: "Email",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "home",
                    field: "home",
                    label: "Home Phone",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "mobile",
                    field: "mobile",
                    label: "Mobile Phone",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "added",
                    field: "added",
                    label: "Added",
                    align: "left",
                    style: "vertical-align: top; min-width: 150px;"
                },
                {
                    name: "referred_by",
                    field: "referred_by",
                    label: "Referred By",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "home_location",
                    field: "home_location",
                    label: "Home Location",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "first_appointment_date",
                    field: "first_appointment_date",
                    label: "First Appointment Date",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "first_invoice_date",
                    field: "first_invoice_date",
                    label: "First Invoice Date",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "first_invoice_amount",
                    field: "first_invoice_amount",
                    label: "First Invoice Amount",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "last_appointment_date",
                    field: "last_appointment_date",
                    label: "Last Appointment Date",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "last_invoice_date",
                    field: "last_invoice_date",
                    label: "Last Invoice Date",
                    align: "left",
                    style: "vertical-align: top"
                },
                {
                    name: "last_invoice_amount",
                    field: "last_invoice_amount",
                    label: "Last Invoice Amount",
                    align: "left",
                    style: "vertical-align: top"
                }
            ]
        };
    },
    computed: {
        summaryTitle() {
            const msg = "Total of New Engaged Clients";
            if (this.homeLocation != "")
                return msg + ` from ${this.homeLocation}:`;
            return msg + ":";
        },
        visibleColumns() {
            // display home_location column only if clinic is record sharing
            let cols = this.columns.map(e => e.field);
            const index = cols.findIndex(e => e == "home_location");

            if (!this.$root.setting.isRecordSharing) cols.splice(index, 1);
            return cols;
        }
    },
    async mounted() {
        let self = this;

        self.data.filterDateOption = true;
        self.data.isShowDateRange = true;
        self.data.isShowHomeLocationOptions = true;
        self.data.reportId = CREPORT.TYPE.NEW_ENGAGED_CLIENTS;
        self.toggleGreyOutButton(true);

        self.data.start = self.getStartDate("isoWeek");
        self.data.end = self.getEndDate("day");

        self.$root.$on(
            "report-filter-date-range:refresh",
            self.handleOnFilterChanged
        );

        self.$root.$on("new_engaged_clients:refresh", self.handleOnRefresh);

        self.$refs.filterDateRange.open(self.data);
    },
    beforeDestroy: function () {
        let self = this;

        self.data.filterDateOption = true;

        self.data.isDestroyed = true;

        self.resetPagination();

        self.$root.$off("new_engaged_clients:refresh");

        self.$root.$off("report-filter-date-range:refresh");

        if (self.abortController.length > 0) {
            self.abortController[self.indexAxios].abort();
        }
        self.toggleGreyOutButton(false);
    },
    methods: {
        async init(isRefresh = false, resetResult = false, indexAxios) {
            let self = this;

            clearInterval(self.pagination.interval);
            self.loadingPercentages();
            self.abortController[indexAxios] = new AbortController();

            await ReportService.getReport(CREPORT.TYPE.NEW_ENGAGED_CLIENTS, {
                ...self.params,
                refresh: isRefresh ? true : false,
                page: self.pagination.page,
                signal: self.abortController[indexAxios].signal
            })
                .then(response => {
                    const reportResponse = response.resource;
                    const length = reportResponse.results.length;

                    if (response.message && response.message.code === 200) {
                        self.dynamicPageTitle(self.title);
                        self.title = reportResponse.meta.title;
                        self.total = reportResponse.paginate.total;
                        self.isRecordSharing = reportResponse.isRecordSharing;
                        self.pagination.lastPage =
                            reportResponse.paginate.lastPage;
                        self.pagination.page++;

                        self.meta = {
                            ...reportResponse.meta,
                            ...reportResponse.paginate
                        };

                        if (resetResult) {
                            self.results = [];
                        }

                        if (length == 0) {
                            self.toggleGreyOutButton(true);
                        } else {
                            if (length > 0) {
                                self.data.isGreyOutButton = false;

                                reportResponse.results.forEach(e => {
                                    self.results.push({
                                        id: e.actor_id,
                                        index: e.actor_index,
                                        encoded_id: e.client_encoded_id,
                                        name: e.name,
                                        address: e.address,
                                        city: e.city,
                                        state: e.state,
                                        zipcode: e.zipcode,
                                        county: e.county,
                                        country: e.country,
                                        email: e.email,
                                        home: e.home,
                                        mobile: e.mobile,
                                        added: e.added,
                                        referred_by: e.referred_by,
                                        home_location: e.home_location,
                                        first_appointment_date:
                                            e.first_appointment_date,
                                        first_invoice_date:
                                            e.first_invoice_date,
                                        first_invoice_amount:
                                            reportResponse.currencySymbol +
                                            e.first_invoice_amount,
                                        last_appointment_date:
                                            e.last_appointment_date,
                                        last_invoice_date: e.last_invoice_date,
                                        last_invoice_amount:
                                            reportResponse.currencySymbol +
                                            e.last_invoice_amount
                                    });
                                });

                                self.length = self.results.length;
                                self.toggleGreyOutButton(false);
                            }
                        }

                        if (self.pagination.page <= self.pagination.lastPage) {
                            self.timer(self.INTERVAL_TIME).then(() => {
                                self.init(isRefresh);
                            });
                        } else {
                            self.loadingCompleted();
                            self.isLoading = false;
                        }
                    } else {
                        self._message(
                            "Error: Unable to get the report",
                            "danger"
                        );
                    }
                })
                .catch(e => {
                    if (!self.abortController[indexAxios].signal.aborted) {
                        console.error(e);
                        self.loaded = true;
                        self._message(
                            "Error: Unable to get the report",
                            "danger"
                        );
                    }
                });
        },
        handleOpenFilter() {
            this.$refs.filterDateRange.open(this.data);
        },
        handleOnRefresh() {
            this.isLoading = true;
            this.loaded = true;
            this.pagination = this.DEFAULT_PAGINATION();
            this.toggleGreyOutButton(true);
            this.length = 0;
            if (this.abortController.length > 0) {
                this.abortController[this.indexAxios].abort();
            }
            this.indexAxios++;
            this.init(true, true, this.indexAxios);
        },
        handleOnFilterChanged(params) {
            this.isLoading = true;
            this.loaded = true;
            this.pagination = this.DEFAULT_PAGINATION();
            this.toggleGreyOutButton(true);
            this.length = 0;
            this.homeLocation = params.home_location?.name ?? "";

            this.params = {
                ...this.params,
                from: params.from,
                to: params.to,
                home_location_id: params.home_location_id,
                perPage: 100
            };

            const from = DateTime.fromSeconds(params.from);
            const to = DateTime.fromSeconds(params.to);

           // set selected date range
            this.dateRange = this.getDateRange(
                params.from,
                params.to
            );

            this.init(false, true, this.indexAxios);
        },
        toggleGreyOutButton(value) {
            let self = this;
            // to grey out the action menu when there is no data / loading
            self.data.isGreyOutButton = value;
        },
        generateClientObject(row) {
            const isDeleted = this.capitalize(row.name).includes("(deleted)");
            return {
                id: isDeleted ? null : row.id,
                name: this.capitalize(row.name.replace("(deleted)", "")),
                encoded_id: isDeleted ? null : row.encoded_id,
                isactive: !isDeleted
            };
        }
    }
};
</script>
<style scoped>
.summary-table h4 {
    margin-left: 0.75rem;
}
.summary-table tr td:first-child {
    width: 1%;
    white-space: nowrap;
}

.summary-table tr td {
    font-size: 1.125rem;
    font-weight: 700;
}
</style>
